<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    persistent
    width="500"
    :role="dialog"
    ref="dialog"
    eager
  >
    <!-- You can't add an ID to v-dialog? Find this then look for the parent. -->
    <span id="ref-span"></span>
    <v-card class="d-flex flex-column pa-5">
      <button
        class="close-button"
        role="button"
        @click="close"
      >
        Close
      </button>
      <section class="d-flex flex-column">
        <h1 class="secondary--text shrink-mobile" id="dialog-label">
          You are now leaving our site
        </h1>
        <v-divider />
        <p class="font-medium">
          You are being redirected to an external link, would you like to
          continue?
        </p>
        <base-button
          role="link"
          color="primary"
          text="Continue"
          class="mt-3"
          block
          @click="route"
        />
      </section>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ExternalLinkDialog',
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    // This is the element that was responsible for opening this warning.
    fromElement: {
      type: HTMLElement,
      required: false
    }
  },
  watch: {
    dialog (newVal, oldVal) {
      // Delay to give time for object to render. Massively ugly, but v-dialog keeps cleaning aria-labelledby attribute. Pain
      setTimeout(function () {
        const dialogEl = document.getElementById('ref-span').parentElement
        dialogEl.setAttribute('aria-labelledby', 'dialog-label')
      }, 100)
    }
  },
  methods: {
    route () {
      window.open(this.link, '_blank')
      this.$emit('close')
    },
    close () {
      this.$emit('close')

      if (this.fromElement) {
        // Pulls in the correct child node that can be focused.
        const el = this.fromElement.childNodes[0]
        // Not sure why, but this delay is needed.
        setTimeout(function () {
          el.focus()
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/variables";

  .close-button{
    right: 20px;
    position: absolute;
    font-size: 15px;
  }

  .close-button:focus{
    outline: 5px auto;
    outline-offset: 4px;
  }

  h1 {
      font-size: 24px !important;
      font-weight: 700 !important;
      line-height: 33px !important;
    }

  @media only screen and (max-width: $breakpoint-sm) {
    .shrink-mobile {
      font-size: 4.5vw;
      width: 90%;
    }
  }
</style>
